import { createClient } from 'contentful';

const client = createClient({
  space: '4zt14dhwh1uc',
  accessToken: 'cdyD7M6Ni0SRjrnSZejv1NWniqnqwqjKSsWK7sRf0HU',
});

export default client;